<template>
  <FormItemWrapper>
    <FormItemLabel slot="label">{{ $t('formItemLabelPowerMeasurement') }}</FormItemLabel>
    <Tooltip
      v-if="$t('formItemTooltipPowerMeasurement')"
      slot="tooltip"
      :content="$t('formItemTooltipPowerMeasurement')"
    />
    <el-select
      v-model="powerMeasurementType"
      :placeholder="$t('formItemPowerMeasurementPlaceholder')"
    >
      <el-option
        v-for="(item, index) in powerMeasurementTypes"
        :key="`item-${index}`"
        :label="$t(item.name)"
        :value="item.id"
      />
    </el-select>
  </FormItemWrapper>
</template>

<script>
import Vue from 'vue';
import { Select, Option } from 'element-ui';
// Components
import FormItemWrapper from '@/components/formItem/Wrapper.vue';
import FormItemLabel from '@/components/formItem/Label.vue';
import Tooltip from '@/components/Tooltip.vue';

Vue.use(Select);
Vue.use(Option);

export default {
  name: 'FilterPowerMeasurement',
  components: {
    FormItemWrapper,
    FormItemLabel,
    Tooltip,
  },
  data() {
    return {
      powerMeasurementTypes: [
        { id: 'with', name: 'powerMeasurementWith' },
        { id: 'without', name: 'powerMeasurementWithout' },
        // {id: 'without_reactive', name: 'withoutReactive'},
        // { id: 'with_reactive', name: 'powerMeasurementWithReactive' },
      ],
    };
  },
  computed: {
    powerMeasurementType: {
      get() {
        return this.$store.state.filter.activeFilters.powerMeasurement;
      },
      set(value) {
        this.$store.commit('filter/SET_POWER_MEASUREMENT', value);
        this.$store.commit('filter/SET_METER_TYPE', 'double_rate_meter');
      },
    },
    selectedLanguage() {
      return this.$i18n.locale();
    },
  },
};
</script>
